"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaV2Api = exports.MediaV2ApiFactory = exports.MediaV2ApiFp = exports.MediaV2ApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * MediaV2Api - axios parameter creator
 * @export
 */
const MediaV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CopyDataToNewRecipient: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, mediaRecipientCopyRequest, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2CopyDataToNewRecipient', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2CopyDataToNewRecipient', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2CopyDataToNewRecipient', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/copy`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/copy`,
                sdkMethod: 'v2CopyDataToNewRecipient',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaRecipientCopyRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2DeleteGuides', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}`,
                sdkMethod: 'v2DeleteGuides',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Expunge recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2ExpungePrograms', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/expunge`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/expunge`,
                sdkMethod: 'v2ExpungePrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgramGuide', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}`,
                sdkMethod: 'v2GetClinicalProgramGuide',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, _class, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('v2GetClinicalProgress', '_class', _class);
            const localVarPath = `/v2/media/recipients/{recipient_id}/clinical/progress`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (_class) {
                localVarQueryParameter['class'] = _class;
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/clinical/progress`,
                sdkMethod: 'v2GetClinicalProgress',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, guideId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'recipientId', recipientId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetGuides', 'guideId', guideId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/guides`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (guideId) {
                localVarQueryParameter['guide_id'] = guideId;
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/guides`,
                sdkMethod: 'v2GetGuides',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, _class, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', 'recipientId', recipientId);
            // verify required parameter '_class' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPacks', '_class', _class);
            const localVarPath = `/v2/media/recipients/{recipient_id}/packs`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (_class) {
                localVarQueryParameter['class'] = _class;
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/packs`,
                sdkMethod: 'v2GetPacks',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, programId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'recipientId', recipientId);
            // verify required parameter 'programId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetPrograms', 'programId', programId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/programs`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (programId) {
                localVarQueryParameter['program_id'] = programId;
            }
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/programs`,
                sdkMethod: 'v2GetPrograms',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get guide config and recipient data for the guide
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetRecipientGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, guideId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2GetRecipientGuide', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2GetRecipientGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetRecipientGuide', 'recipientId', recipientId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('v2GetRecipientGuide', 'guideId', guideId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'guide_id'}}`, encodeURIComponent(String(guideId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/guides/{guide_id}`,
                sdkMethod: 'v2GetRecipientGuide',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, acceptLanguage, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2MediaGuideRecommendations', 'recipientId', recipientId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/recommendations/guides`.replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/recommendations/guides`,
                sdkMethod: 'v2MediaGuideRecommendations',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, circleAuthorizationToken, recipientId, guideId, acceptLanguage, mediaUpdateGuide, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'rHGApp', rHGApp);
            // verify required parameter 'circleAuthorizationToken' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'circleAuthorizationToken', circleAuthorizationToken);
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'recipientId', recipientId);
            // verify required parameter 'guideId' is not null or undefined
            (0, common_1.assertParamExists)('v2UpdateGuide', 'guideId', guideId);
            const localVarPath = `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
                .replace(`{${'recipient_id'}}`, encodeURIComponent(String(recipientId)))
                .replace(`{${'guide_id'}}`, encodeURIComponent(String(guideId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp !== undefined && rHGApp !== null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            if (circleAuthorizationToken !== undefined &&
                circleAuthorizationToken !== null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage !== undefined && acceptLanguage !== null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v2/media/recipients/{recipient_id}/guides/{guide_id}`,
                sdkMethod: 'v2UpdateGuide',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(mediaUpdateGuide, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.MediaV2ApiAxiosParamCreator = MediaV2ApiAxiosParamCreator;
/**
 * MediaV2Api - functional programming interface
 * @export
 */
const MediaV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.MediaV2ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CopyDataToNewRecipient(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2CopyDataToNewRecipient(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2DeleteGuides(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Expunge recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2ExpungePrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetClinicalProgramGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetClinicalProgress(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetGuides(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPacks(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetPrograms(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get guide config and recipient data for the guide
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetRecipientGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2GetRecipientGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2MediaGuideRecommendations(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2UpdateGuide(params, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.MediaV2ApiFp = MediaV2ApiFp;
/**
 * MediaV2Api - factory interface
 * @export
 */
const MediaV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.MediaV2ApiFp)(configuration);
    return {
        /**
         * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
         * @summary v1 Copy Data To New Recipient
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2CopyDataToNewRecipient(params, options) {
            return localVarFp
                .v2CopyDataToNewRecipient(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Soft delete recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2DeleteGuides(params, options) {
            return localVarFp
                .v2DeleteGuides(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Expunge recipient\'s guides progress
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2ExpungePrograms(params, options) {
            return localVarFp
                .v2ExpungePrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get recently played clinical guides, favorite clinical guides
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgramGuide(params, options) {
            return localVarFp
                .v2GetClinicalProgramGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch user\'s progress of clinical media
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetClinicalProgress(params, options) {
            return localVarFp
                .v2GetClinicalProgress(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetGuides(params, options) {
            return localVarFp
                .v2GetGuides(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPacks(params, options) {
            return localVarFp
                .v2GetPacks(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;...
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetPrograms(params, options) {
            return localVarFp
                .v2GetPrograms(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get guide config and recipient data for the guide
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2GetRecipientGuide(params, options) {
            return localVarFp
                .v2GetRecipientGuide(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2MediaGuideRecommendations(params, options) {
            return localVarFp
                .v2MediaGuideRecommendations(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} guideId Guide ID
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {MediaUpdateGuide} [mediaUpdateGuide]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2UpdateGuide(params, options) {
            return localVarFp
                .v2UpdateGuide(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.MediaV2ApiFactory = MediaV2ApiFactory;
/**
 * MediaV2Api - object-oriented interface
 * @export
 * @class MediaV2Api
 * @extends {BaseAPI}
 */
class MediaV2Api extends base_1.BaseAPI {
    /**
     * URL `/v2/media/recipients/{recipient_id}/copy`
     * Copies all the data that is associated with the provided recipientID to the target recipient ID provided in the body. If data exists for the target recipient ID then nothing is copied or overwritten.    |Feature|Dataclass|Permission|   |-------|---------|----------|   | media | media | c |
     * @summary v1 Copy Data To New Recipient
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaRecipientCopyRequest} [mediaRecipientCopyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2CopyDataToNewRecipient(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2CopyDataToNewRecipient(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}`
     * Soft delete recipient\'s guides progress
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2DeleteGuides(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2DeleteGuides(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/expunge`
     * Expunge recipient\'s guides progress
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2ExpungePrograms(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2ExpungePrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}`
     * Get recently played clinical guides, favorite clinical guides
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetClinicalProgramGuide(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetClinicalProgramGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/clinical/progress`
     * Fetch user\'s progress of clinical media
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetClinicalProgress(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetClinicalProgress(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/guides`
     * Fetch Guides configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides have any progress, the response will contain the progress data.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} guideId One or more guide IDs, sent in the form guide_id&#x3D;2FV22gFtM_&amp;guide_id&#x3D;2FV22gFtM_&amp;...
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetGuides(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetGuides(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/packs`
     * Fetch Packs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service. If pack items(guides) have any progress, the response will contain the progress data.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} _class One or more pack classes, sent in the form class[]&#x3D;calm-health-anxiety&amp;class[]&#x3D;calm-health-depression&amp;...
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetPacks(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPacks(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/programs`
     * Fetch Programs configuration from Media Service. Media Service will act as a pass-through and fetch from Calm DTC Content-Service If guides in the programs have any progress, the response will contain the progress data.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {Array<string>} programId One or more program IDs, sent in the form program_id&#x3D;BxIC0D7a9z&amp;program_id&#x3D;BxIC0D7a9z&amp;...
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetPrograms(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetPrograms(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
     * Get guide config and recipient data for the guide
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} guideId Guide ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2GetRecipientGuide(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2GetRecipientGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/recommendations/guides`
     * Get media recommendations for the recipient. Recommendations are based on the recipient\'s most recent listen guides.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2MediaGuideRecommendations(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2MediaGuideRecommendations(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v2/media/recipients/{recipient_id}/guides/{guide_id}`
     * Given Guide ID, Program ID, Pack Class, and Recipient ID update a guide. Guide update request body must contain at least one of the optional fields. If all fields are empty in the guide update request body, the server will return http status 400
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} circleAuthorizationToken Circle JWT token that contains user\&#39;s role, cohort, permissions, features and circle information
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} guideId Guide ID
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {MediaUpdateGuide} [mediaUpdateGuide]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MediaV2Api
     */
    v2UpdateGuide(params, options) {
        return (0, exports.MediaV2ApiFp)(this.configuration)
            .v2UpdateGuide(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.MediaV2Api = MediaV2Api;
//# sourceMappingURL=media-v2-api.js.map